import { defineMessages } from 'react-intl';

export default defineMessages({
    step1Title: {
        id: 'portal.views.NewService.Wizard.Steps.Step1.Title',
        defaultMessage: '1. Find and select claim'
    },
    step2Title: {
        id: 'portal.views.NewService.Wizard.Steps.Step2.Title',
        defaultMessage: '2. Create new service'
    }
});
